import './index.css';

const hasOpenModal = 'has-openModal';
const modalComponent = '.c-modal';
const modalClose = '.js-closeModal';
const modalOpen = '.js-openModal';
const modalShow = 'js-modalShow';

/**
 * Returns all focusable elements within a container.
 */
function getFocusableElements(container) {
  return container.querySelectorAll(
    'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])',
  );
}

/**
 * Traps keyboard focus within a modal when Tab is pressed.
 */
function trapFocus(event, modal) {
  const focusableElements = getFocusableElements(modal);
  if (focusableElements.length === 0) return;

  const firstFocusable = focusableElements[0];
  const lastFocusable = focusableElements[focusableElements.length - 1];

  if (event.shiftKey && document.activeElement === firstFocusable) {
    event.preventDefault();
    lastFocusable.focus();
  } else if (!event.shiftKey && document.activeElement === lastFocusable) {
    event.preventDefault();
    firstFocusable.focus();
  }
}

/**
 * Closes a modal: removes show class, hides after transition,
 * restores body scroll, and returns focus to the trigger element.
 */
function closeModal(modal, triggerElement) {
  modal.classList.remove(modalShow);

  setTimeout(() => {
    modal.style.display = 'none'; // eslint-disable-line no-param-reassign
  }, 300);

  document.body.classList.remove(hasOpenModal);

  if (triggerElement) {
    triggerElement.focus();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const openModalButtons = document.querySelectorAll(modalOpen);
  const closeModalButtons = document.querySelectorAll(modalClose);
  const modals = document.querySelectorAll(modalComponent);

  // Track which element triggered the currently open modal
  let activeTrigger = null;

  openModalButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const modalId = button.getAttribute('data-modal-id');
      const modal = document.getElementById(modalId);

      activeTrigger = button;
      modal.style.display = 'block';

      setTimeout(() => {
        modal.classList.add(modalShow);

        // Focus the first focusable element inside the modal (close button)
        const focusableElements = getFocusableElements(modal);
        if (focusableElements.length > 0) {
          focusableElements[0].focus();
        }
      }, 10);

      document.body.classList.add(hasOpenModal);
    });
  });

  closeModalButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const modal = button.closest(modalComponent);
      closeModal(modal, activeTrigger);
      activeTrigger = null;
    });
  });

  // Close on backdrop click
  window.addEventListener('click', (event) => {
    modals.forEach((modal) => {
      if (event.target === modal) {
        closeModal(modal, activeTrigger);
        activeTrigger = null;
      }
    });
  });

  // Close on Escape key & trap focus with Tab
  window.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      modals.forEach((modal) => {
        if (modal.style.display === 'block') {
          closeModal(modal, activeTrigger);
          activeTrigger = null;
        }
      });
    }

    if (event.key === 'Tab') {
      modals.forEach((modal) => {
        if (modal.style.display === 'block') {
          trapFocus(event, modal);
        }
      });
    }
  });
});
